/* @flow */

import * as types from './uiSupportActionTypes';

export function resetPasswordSupportSection() {
  return {
    type: types.RESET_PASSWORD_SUPPORT_SECTION,
  };
}

export function showPasswordSupportLinkSection() {
  return {
    type: types.SHOW_PASSWORD_SUPPORT_LINK_SECTION,
  };
}

export function showPasswordSupportResetSection() {
  return {
    type: types.SHOW_PASSWORD_SUPPORT_RESET_SECTION,
  };
}

export function showPasswordSupportContactSection() {
  return {
    type: types.SHOW_PASSWORD_SUPPORT_CONTACT_SECTION,
  };
}
